import { Badge } from '@package/subframe/components/Badge';
import { IconWithLogoBackground } from '@package/subframe/components/IconWithLogoBackground';
import { FeatherLock } from '@subframe/core';

interface UpgradePromptProps {
  requiredPlan: string;
  featureName?: string;
  compact?: boolean;
}

export function UpgradePrompt({ requiredPlan, featureName, compact = false }: UpgradePromptProps) {
  if (compact) {
    return (
      <div className="flex items-center gap-1.5 text-caption font-caption text-neutral-500">
        <FeatherLock className="h-3 w-3" />
        <span>{requiredPlan} plan</span>
      </div>
    );
  }

  const featureLabel = featureName ?? 'This feature';

  return (
    <div className="flex w-full items-center justify-center px-6 pt-8 pb-6">
      <div className="flex w-256 max-w-full flex-col items-center gap-6 rounded-lg bg-default-background px-8 py-16">
        <IconWithLogoBackground variant="brand" size="large" icon={<FeatherLock />} />
        <div className="flex flex-col items-center gap-3">
          <Badge variant="neutral" icon={<FeatherLock />}>
            {requiredPlan} plan
          </Badge>
          <div className="flex flex-col items-center gap-2">
            <span className="text-heading-2 font-heading-2 text-primary-navy-800">{featureLabel}</span>
            <span className="text-body font-body text-subtext-color text-center max-w-sm">
              This feature is available on the {requiredPlan} plan. Contact Naud to upgrade.
            </span>
          </div>
        </div>
        <a
          href="mailto:hello@naud.app?subject=Upgrade%20enquiry"
          className="inline-flex h-8 cursor-pointer items-center justify-center gap-2 rounded-md border border-solid border-primary-navy-600 bg-transparent px-3 text-body-bold font-body-bold text-primary-navy-600 hover:bg-primary-navy-50 active:bg-primary-navy-100 transition-colors"
        >
          Contact us to upgrade
        </a>
      </div>
    </div>
  );
}
